// Icon size variants
export const ICON_SIZES = {
  xs: '16px',
  small: '20px',
  medium: '24px',
  large: '32px',
  xl: '40px',
} as const;

// Icon colors
export const ICON_COLORS = {
  primary: '#1976d2',
  secondary: '#637381',
  success: '#2e7d32',
  error: '#d32f2f',
  warning: '#ed6c02',
  info: '#0288d1',
  textPrimary: '#1976d2',
  textSecondary: '#637381',
  textSuccess: '#2e7d32',
  grey: '#9e9e9e',
  green: '#00AB55',
} as const;

// Base icon styles
export const BASE_ICON_STYLES = {
  small: {
    fontSize: 'small',
    style: {
      color: ICON_COLORS.success,
      marginRight: '8px',
      marginTop: '2px',
      flexShrink: 0,
    },
  },
  medium: {
    fontSize: 'medium',
    style: {
      color: ICON_COLORS.success,
      marginRight: '12px',
      marginTop: '2px',
      flexShrink: 0,
    },
  },
  large: {
    fontSize: 'large',
    style: {
      color: ICON_COLORS.primary,
      marginLeft: '8px',
    },
  },
} as const;

// Iconify icon styles
export const ICONIFY_STYLES = {
  small: {
    style: {
      color: ICON_COLORS.success,
      marginRight: '8px',
      marginTop: '2px',
      flexShrink: 0,
      fontSize: '20px',
    },
  },
  medium: {
    style: {
      color: ICON_COLORS.success,
      marginRight: '12px',
      marginTop: '2px',
      flexShrink: 0,
      fontSize: '20px',
    },
  },
} as const;

// Tour-specific icon styles
export const TOUR_ICON_STYLES = {
  header: {
    style: {
      color: ICON_COLORS.primary,
      marginLeft: '8px',
    },
  },
  filter: {
    style: {
      color: ICON_COLORS.textSecondary,
      marginLeft: '8px',
    },
  },
  welcome: {
    style: {
      color: ICON_COLORS.green,
      marginLeft: '8px',
    },
  },
  dailyEmail: {
    style: {
      color: ICON_COLORS.grey,
      marginLeft: '8px',
    },
  },
} as const;

// Layout constants
export const LAYOUT = {
  defaultHeaderHeight: 160, // Default header height in pixels (before buffer)
  headerHeightBuffer: 20, // Additional spacing buffer in pixels
  get totalDefaultHeaderHeight() {
    return this.defaultHeaderHeight + this.headerHeightBuffer;
  },
} as const;

// Type definitions
export type IconSize = keyof typeof ICON_SIZES;
export type IconColor = keyof typeof ICON_COLORS;
